import React from 'react'
import { useTheme } from '@mui/material/styles'
import styled from 'styled-components'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@/v2/components/common/Typography'
import { formatPhone } from '@/v2/utils/format'
import { usePatientOfficeNotes } from '@/v2/hooks/patient/usePatientNotes'
import Note from '@/v2/modals/appointment/AppointmentDetails/Note'

const CloseButton = styled(CloseIcon)`
  position: absolute;
  cursor: pointer;
  top: 8px;
  right: 8px;

  &:hover {
    opacity: 0.6;
  }
`

const Wrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.primary.main};
  border-radius: 4px;
  padding: 10px;
  max-width: 440px;
  width: 100%;
  margin: 0 auto;
  position: relative;
`
const Content = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`

const AlertNotes = styled.div`
  max-width: 440px;
  width: 100%;
  margin: 0 auto;
  position: relative;
`
const Info = styled.div``

const SelectedPatient = ({ registeredPatient, canRemove = true, onChange }) => {
  const theme = useTheme()
  const { notes } = usePatientOfficeNotes(registeredPatient.id)
  const alertNotes = notes?.filter(note => note?.alerts)

  return (
    <>
      <Wrapper theme={theme.palette}>
        {canRemove && (
          <CloseButton
            alt="Remove patient"
            fontSize="small"
            onClick={onChange}
          />
        )}
        <Content>
          <Typography fontSize="13px">{registeredPatient.fullName}</Typography>
          <Info>
            <Typography fontSize="13px">{registeredPatient.email}</Typography>
            <Typography fontSize="13px">
              {formatPhone(registeredPatient.phoneNumber)}
            </Typography>
          </Info>
        </Content>
      </Wrapper>
      <AlertNotes>
        {alertNotes && alertNotes.length > 0 && (
          <>
            {alertNotes.map(note => (
              <Note
                note={note}
                appointmentId={registeredPatient.id}
                doctorId={registeredPatient.id}
                key={note.id}
              />
            ))}
          </>
        )}
      </AlertNotes>
    </>
  )
}

export default SelectedPatient
